import { useState, useEffect } from 'react';
import API from '../api';

// Shared, admin-configurable branding/business info (Settings > Homepage
// Content) — the login screen, the admin sidebar, and the public booking
// page all render the same values instead of each hardcoding its own
// company name, logo, currency, business hours, and hero stats. Backed by
// GET /public/homepage, which is unauthenticated so it works pre-login too.
//
// A tiny module-level cache means the first component to mount fetches it
// and every other component on the same page load reuses that result
// instead of firing its own request.
let cache = null;
let inFlight = null;

const DEFAULTS = {
    system_name: '',
    logo_url: '',
    currency: 'RWF',
    hours: 'Mon–Fri, 8am–6pm',
    stat_rating: '4.9',
    stat_availability: '24/7',
    phone: '',
    address: '',
    contact_email: '',
};

function fetchSettings() {
    if (cache) return Promise.resolve(cache);
    if (!inFlight) {
        inFlight = API.get('/public/homepage')
            .then(r => { cache = r.data; return cache; })
            .catch(() => DEFAULTS)
            .finally(() => { inFlight = null; });
    }
    return inFlight;
}

export function useSiteSettings() {
    const [settings, setSettings] = useState(cache || DEFAULTS);
    const [loaded, setLoaded] = useState(!!cache);

    useEffect(() => {
        let mounted = true;
        fetchSettings().then(data => {
            if (mounted) { setSettings(data); setLoaded(true); }
        });
        return () => { mounted = false; };
    }, []);

    return {
        systemName: settings.system_name || '',
        logoUrl: settings.logo_url || '',
        currency: settings.currency || 'RWF',
        hours: settings.hours || DEFAULTS.hours,
        statRating: settings.stat_rating || DEFAULTS.stat_rating,
        statAvailability: settings.stat_availability || DEFAULTS.stat_availability,
        phone: settings.phone || '',
        address: settings.address || '',
        contactEmail: settings.contact_email || '',
        loaded,
    };
}

export function formatMoney(amount, currency) {
    return `${currency || 'RWF'} ${Number(amount || 0).toLocaleString()}`;
}
